import { Col, Row } from 'antd'
import React, { useState, useEffect } from 'react'
import ExplanationText from '../components/ExplanationText'
import AnnotateNewSequenceTool from '../components/MainTool'
import HistoricAnnotationResults from '../components/HistoricAnnotationResults'
import { RefLanguage } from '../hooks/LanguageHooks'
import { CustomGeneralButton } from '../elements/CustomButtons'
import { PlusCircleFilled } from '@ant-design/icons'



function MainToolInputPage({ onModeToggle, isNewAnalysisMode }) {

    // Translation
    const i18n = RefLanguage()

    // Is adding new sequence (default, true = new analysis mode)
    const [isAddingNewSequence, setisAddingNewSequence] = useState(isNewAnalysisMode !== undefined ? isNewAnalysisMode : true)

    // Update the local state when the prop changes
    useEffect(() => {
        if (isNewAnalysisMode !== undefined) {
            setisAddingNewSequence(isNewAnalysisMode)
        }
    }, [isNewAnalysisMode])

    // Function to handle mode changes
    const handleModeChange = (newMode) => {
        setisAddingNewSequence(newMode)
        if (onModeToggle) {
            onModeToggle(newMode)
        }
    }

    return (
        <Row style={{ minHeight: "var(--body-height)" }}>
            <Col span={10} style={{ minHeight: "var(--body-height)" }}>
                <div className='componentContainer' >
                    <ExplanationText />
                </div>
            </Col>
            <Col span={14} style={{ minHeight: "var(--body-height)" }}>
                <div className='componentContainer' >

                    {isAddingNewSequence === true
                        ? <AnnotateNewSequenceTool />
                        : <div>
                            <HistoricAnnotationResults />
                            <div style={{ marginTop: "2vh", textAlign: "center" }}>
                                <CustomGeneralButton onClick={() => handleModeChange(true)}>
                                    <PlusCircleFilled /> {i18n.t("annotateNewSequence")}
                                </CustomGeneralButton>
                            </div>
                        </div>
                    }
                </div>
            </Col>

        </Row>
    )
}

export default MainToolInputPage
